import { RegionType } from "graphql/generated";

export const CovidTeleConsult = "covid_teleconsult";

export const Evaluations = {
  sg: {
    noah: [
      {
        name: "Erectile Dysfunction",
        icon: "erectile-dysfunction-icon",
        code: "ed"
      },
      {
        name: "Premature Ejaculation",
        icon: "premature-ejaculation-icon",
        code: "pe"
      },
      { name: "Hair Loss", icon: "hairloss-icon", code: "hairloss" },
      // { name: "Acne", icon: "acne-icon", code: "acne" },
      { name: "Weight Loss", icon: "weight-loss-icon", code: "weight_loss" },
      // {
      //   name: "Smoking Cessation",
      //   icon: "smoking-cessation-icon",
      //   code: "smoking_cessation",
      // },
      {
        name: "Individual Therapy",
        icon: "individual-therapy-icon",
        code: "therapy"
      }
      // {
      //   name: "Sleep",
      //   icon: "smoking-cessation-icon",
      //   code: "smoking_cessation",
      // },
    ],
    zoey: [
      {
        name: "Acne",
        icon: "Zoey-Acne Icon",
        code: "acne_zoey"
      },
      {
        name: "Birth Control",
        icon: "Zoey-Birth Control Icon",
        code: "birth_control"
      },
      {
        name: "Hairloss",
        icon: "Zoey-Hair Loss Icon",
        code: "hairloss_zoey"
      },
      {
        name: "Emergency Contraception",
        icon: "Zoey-Emergency Con Icon",
        code: "emergency_contraception"
      },
      {
        name: "Individual Therapy",
        icon: "Zoey-Therapy Icon",
        code: "therapy_zoey"
      },
      {
        name: "Weight Loss",
        icon: "Zoey-Weight Loss Icon",
        code: "weight_loss_zoey"
      }
    ]
  },
  hk: {
    noah: [
      {
        name: "Erectile Dysfunction",
        icon: "erectile-dysfunction-icon",
        code: "ed"
      },
      {
        name: "Premature Ejaculation",
        icon: "premature-ejaculation-icon",
        code: "pe"
      },
      {
        name: "Hair Loss",
        icon: "hairloss-icon",
        code: "hairloss"
      },
      {
        name: "Individual Therapy",
        icon: "individual-therapy-icon",
        code: "therapy"
      },
      {
        name: "Weight Loss",
        icon: "weight-loss-icon",
        code: "weight_loss"
      }
    ],
    zoey: [
      {
        name: "Weight Loss",
        icon: "Zoey-Weight Loss Icon",
        code: "weight_loss_zoey"
      }
    ]
  },
  jp: {
    noah: [
      {
        name: "ED",
        shortName: "ed",
        icon: "erectile-dysfunction-icon",
        code: "ed"
      },
      {
        name: "PE",
        shortName: "pe",
        icon: "premature-ejaculation-icon",
        code: "pe"
      },
      {
        name: "AGA",
        shortName: "AGA",
        icon: "hairloss-icon",
        code: "hairloss"
      },
      {
        name: "Weight Loss",
        shortName: "Weight Loss",
        icon: "weight-loss-icon",
        code: "weight_loss"
      }
    ],
    zoey: [
      {
        name: "Weight Loss",
        icon: "Zoey-Weight Loss Icon",
        code: "weight_loss_zoey"
      }
    ]
  }
};

export const getEvalNameByCode = (
  country: RegionType | string,
  code: string,
  platform = "noah"
) => {
  const evals = Evaluations[country]?.[platform] || [];
  return evals.find((e) => e.code === code)?.name || code;
};
